import * as e from "react";
import { p as m } from "./index-efd35e77.js";
import { c as o } from "./package-metadata-9ad1330d.js";
var s = e.forwardRef(function(a, n) {
  var r = e.useRef(null), t = e.useRef(null);
  e.useImperativeHandle(t, function() {
    return { element: r.current };
  }), e.useImperativeHandle(n, function() {
    return { element: r.current };
  });
  var c = e.useMemo(function() {
    return o("k-spacer", a.className);
  }, [a.className]);
  return e.createElement("span", { ref: r, className: c });
});
s.displayName = "KendoReactToolbarSpacer";
s.propTypes = {
  className: m.string
};
export {
  s as T
};
